import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import './EmailPage.css';

function EmailPage() {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => { document.title = 'PEC - Email'; }, []);

  // Mock data for emails - you can replace with real data
  const emails = [
    {
      id: 1,
      sender: 'Maria González',
      senderEmail: 'maria.gonzalez@empresa.com',
      subject: 'Propuesta de colaboración estratégica Q1 2024',
      preview: 'Estimado equipo, tras nuestra reunión del viernes, he preparado una propuesta detallada para la colaboración estratégica...',
      time: '2 min ago',
      isRead: false,
      isImportant: true,
      hasAttachment: true,
      priority: 'high',
      avatar: '👩‍💼',
      category: 'business'
    },
    {
      id: 2,
      sender: 'Carlos Mendoza',
      senderEmail: 'carlos@techstartup.io',
      subject: 'Actualización del proyecto - Milestone completado',
      preview: 'Hola! Excelentes noticias. Hemos completado el milestone 3 del proyecto con dos días de anticipación...',
      time: '15 min ago',
      isRead: false,
      isImportant: false,
      hasAttachment: false,
      priority: 'medium',
      avatar: '👨‍💻',
      category: 'project'
    },
    {
      id: 3,
      sender: 'Ana Rodríguez',
      senderEmail: 'ana.rodriguez@consultoria.com',
      subject: 'Urgente: Revisión de documentos legales',
      preview: 'Por favor revisar los documentos adjuntos antes de la reunión de mañana. Hay algunos puntos críticos que debemos...',
      time: '1 hour ago',
      isRead: true,
      isImportant: true,
      hasAttachment: true,
      priority: 'high',
      avatar: '⚖️',
      category: 'legal'
    },
    {
      id: 4,
      sender: 'Newsletter Tech',
      senderEmail: 'noreply@technews.com',
      subject: 'Las 10 tendencias tecnológicas más importantes de esta semana',
      preview: 'Descubre las últimas innovaciones en IA, blockchain y desarrollo web que están transformando la industria...',
      time: '3 hours ago',
      isRead: true,
      isImportant: false,
      hasAttachment: false,
      priority: 'low',
      avatar: '📰',
      category: 'newsletter'
    },
    {
      id: 5,
      sender: 'Sistema Bancario',
      senderEmail: 'notificaciones@banco.com',
      subject: 'Confirmación de transferencia - $2,500.00',
      preview: 'Se ha procesado exitosamente tu transferencia por $2,500.00 a la cuenta terminada en 4578...',
      time: '5 hours ago',
      isRead: false,
      isImportant: true,
      hasAttachment: true,
      priority: 'medium',
      avatar: '🏦',
      category: 'finance'
    },
    {
      id: 6,
      sender: 'Calendario Google',
      senderEmail: 'calendar-notification@google.com',
      subject: 'Recordatorio: Reunión con cliente en 1 hora',
      preview: 'Tu reunión "Presentación propuesta Q1" con Juan Pérez está programada para las 14:00 hoy...',
      time: '1 hour from now',
      isRead: false,
      isImportant: true,
      hasAttachment: false,
      priority: 'high',
      avatar: '📅',
      category: 'calendar'
    }
  ];

  const emailStats = {
    unread: emails.filter(email => !email.isRead).length,
    important: emails.filter(email => email.isImportant).length,
    total: emails.length,
    withAttachments: emails.filter(email => email.hasAttachment).length
  };

  // Filter emails based on search term
  const filteredEmails = emails.filter(email =>
    email.sender.toLowerCase().includes(searchTerm.toLowerCase()) ||
    email.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
    email.preview.toLowerCase().includes(searchTerm.toLowerCase()) ||
    email.senderEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
    email.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleMarkAsRead = (emailId) => {
    console.log('Marking email as read:', emailId);
    // Implement mark as read functionality
  };

  const handleMarkImportant = (emailId) => {
    console.log('Marking email as important:', emailId);
    // Implement mark as important functionality
  };

  const handleComposeEmail = () => {
    console.log('Composing new email');
    // Implement compose email functionality
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'blue';
      default: return 'gray';
    }
  };

  return (
    <div className="email-page">
      <Header 
        currentPage="email" 
        showSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showAddButton 
        onAddNew={handleComposeEmail}
      />

      <div className="email-content">
        {/* Email Stats */}
        <div className="email-stats">
          <div className="stat-card unread">
            <div className="stat-icon">📧</div>
            <div className="stat-content">
              <h3>{emailStats.unread}</h3>
              <p>No Leídos</p>
            </div>
          </div>
          <div className="stat-card important">
            <div className="stat-icon">⭐</div>
            <div className="stat-content">
              <h3>{emailStats.important}</h3>
              <p>Importantes</p>
            </div>
          </div>
          <div className="stat-card attachments">
            <div className="stat-icon">📎</div>
            <div className="stat-content">
              <h3>{emailStats.withAttachments}</h3>
              <p>Con Adjuntos</p>
            </div>
          </div>
          <div className="stat-card total">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <h3>{emailStats.total}</h3>
              <p>Total Emails</p>
            </div>
          </div>
        </div>

        {/* Emails List */}
        <div className="emails-section">
          <div className="section-header">
            <h2>Bandeja de Entrada ({filteredEmails.length})</h2>
            <div className="section-actions">
              <button className="btn-secondary">Marcar Todos Leídos</button>
              <button className="btn-secondary">Filtros</button>
              <button className="btn-secondary">Sincronizar</button>
            </div>
          </div>

          <div className="emails-list">
            {filteredEmails.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">📭</div>
                <h3>No se encontraron emails</h3>
                <p>Intenta ajustar los términos de búsqueda o sincronizar tu bandeja de entrada</p>
              </div>
            ) : (
              filteredEmails.map((email) => (
                <div key={email.id} className={`email-card ${email.isRead ? 'read' : 'unread'} ${getPriorityColor(email.priority)}`}>
                  <div className="email-header">
                    <div className="email-avatar">
                      <span>{email.avatar}</span>
                    </div>
                    <div className="email-meta">
                      <div className="email-sender">
                        {email.sender}
                        {email.isImportant && <span className="important-marker">⭐</span>}
                        {email.hasAttachment && <span className="attachment-marker">📎</span>}
                      </div>
                      <div className="email-time">{email.time}</div>
                    </div>
                    <div className={`priority-badge ${email.priority}`}>
                      {email.priority}
                    </div>
                  </div>
                  <div className="email-content">
                    <h4 className={`email-subject ${!email.isRead ? 'unread-subject' : ''}`}>
                      {email.subject}
                    </h4>
                    <p className="email-preview">{email.preview}</p>
                    <div className="email-details">
                      <span className="email-address">{email.senderEmail}</span>
                      <span className={`category-tag ${email.category}`}>{email.category}</span>
                    </div>
                  </div>
                  <div className="email-actions">
                    <button 
                      className={`btn-action ${email.isRead ? 'secondary' : 'primary'}`}
                      onClick={() => handleMarkAsRead(email.id)}
                    >
                      {email.isRead ? 'Marcar No Leído' : 'Marcar Leído'}
                    </button>
                    <button 
                      className={`btn-action ${email.isImportant ? 'warning' : 'secondary'}`}
                      onClick={() => handleMarkImportant(email.id)}
                    >
                      {email.isImportant ? 'Quitar Importante' : 'Marcar Importante'}
                    </button>
                    <button className="btn-action secondary">Responder</button>
                    <button className="btn-action danger">Eliminar</button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions-section">
          <h2>Gestión Rápida</h2>
          <div className="quick-actions-grid">
            <div className="quick-action-card">
              <div className="action-icon">📥</div>
              <h3>Bandeja de Entrada</h3>
              <p>Administrar emails recibidos</p>
              <button className="btn-primary">Ver Bandeja</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">📤</div>
              <h3>Emails Enviados</h3>
              <p>Revisar emails enviados</p>
              <button className="btn-primary">Ver Enviados</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">⭐</div>
              <h3>Importantes</h3>
              <p>Emails marcados como importantes</p>
              <button className="btn-primary">Ver Importantes</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">🗂️</div>
              <h3>Organizar</h3>
              <p>Crear etiquetas y filtros</p>
              <button className="btn-primary">Organizar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailPage;
